import { Dispatch } from 'react';
import { createContext } from 'use-context-selector';
import { PayloadAction } from 'typesafe-actions';
import { PayrollState, PayrollContextActionTypes } from './types';
import { defaultPayrollState } from './defaultState';

const PayrollContext = createContext<Partial<PayrollState>>(defaultPayrollState);
const PayrollDispatchContext = createContext<Dispatch<PayloadAction<PayrollContextActionTypes, any>> | undefined>(
  undefined,
);

export { PayrollContext, PayrollDispatchContext };
